import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const ModalFooter = ({ children, className, ...rest }) => {
  const classes = cn(
    'c-button-group  c-button-group--right  c-modal__footer',
    className
  );
  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
};

export default ModalFooter;

ModalFooter.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

ModalFooter.defaultProps = {
  children: null,
  className: '',
};
